<template>

  <form-container :title="stageTitle">

  <p>Please select the details of the device you wish to claim for and click Add.</p>  
  <p>You can add more than one device to this claim and they will appear below.</p>
  <hr />
  <div class="mt-3 mb-5 col-md-7">
    <device-list v-if="claimFormGadgets.length > 0">
      <template slot="subheader"></template>
      <template v-for="(device, index) in claimFormGadgets">
        <div :key="index" class="bs-list-content-row">
          <div class="bs-list-content-row-description-icon">              
            <i class="fas" :class="gadgetTypeIcon(device.deviceTypeId)"></i>                       
          </div>
          <div class="bs-list-content-row-description">
            {{deviceLabel(device)}}   
          </div>
          <div style="flex-grow: 1"></div>
          <button class="ml-5 btn btn-danger btn-sm" 
                  @click="handleRemoveGadget(device)" 
                  style="width:25%; min-width: 70px;">Remove</button>
        </div>
      </template>
      <p class="mt-3">Once you have added all the devices you wish to claim for then click Next.</p>
    </device-list>
</div>
 <hr v-if="claimFormGadgets.length > 0" />
    <div class="row">
      <div class="col-sm">
        <label for="type">Type</label>
        <select id="type" 
                fieldlabel="Device Type"  
                v-model="addGadgetObj.deviceTypeId"                
                class="form-control form-control-lg">
          <option :value="null">SELECT...</option>
          <option v-for="(deviceType, index) in deviceTypes" :key="'deviceType' + index" :value="deviceType.id">
            {{deviceType.label}}
          </option>
        </select>
        <div name="type" invalidfeedback="Please select the type of gadget"></div> 
      </div>
      <div class="col-sm">
        <label for="make">Make</label>
        <multi-role-select selectPlaceholder="SELECT..."
                           :selectOptions="deviceMakes"
                           selectOptionText="label"
                           selectOptionValue="id"
                           selectOptionCustomText="Add unlisted make"
                           customInputPlaceholder="Gadget make"
                           v-model="addGadgetObj.deviceMakeId"
                           :feedback-value="addGadgetObj.deviceMakeId"
                           @custom-option="customMakeSelected"
                           :isCustomOption="customMake"
                           :isLoading="makeLoad"></multi-role-select>
        <div name="make" invalidfeedback="Please select the make of gadget"></div> 
      </div>
      <div class="col-sm">
        <label for="model">Model</label>
        <multi-role-select selectPlaceholder="SELECT..."
                           :selectOptions="deviceModels"
                           selectOptionText="label"
                           selectOptionValue="id"
                           selectOptionCustomText="Add unlisted model"
                           customInputPlaceholder="Gadget model"
                           v-model="addGadgetObj.deviceModelId"
                           :feedback-value="addGadgetObj.deviceModelId"
                           :isLoading="modelLoad"
                           :isCustomOption="customModel"
                           @custom-option="customModelSelected"></multi-role-select>
        <div name="make" invalidfeedback="Please select the model of gadget"></div> 
      </div>

      <div class="col-sm">
        <label for="value">Value</label>        
        <div class="gbp">
          <input type="number" 
                 class="form-control form-control-lg multi_role_value_input" 
                 id="value" fieldlabel="Gadget value"
                 v-model="addGadgetObj.value">
          <span class="simple_tooltip">Please provide the value of the gadget when new to the nearest pound.</span>
        </div>        
      </div>

    </div>
    <div class="row">
      <div class="col-sm text-right">
        <button class="button add_gadget_button" @click="handleAddGadgetClick" v-bind:disabled="isCompletedRow === false">Add</button>
      </div>
    </div>

    <div class="invalid-feedback d-block bumper" v-if="feedbackMsg">{{feedbackMsg}}</div>

    <form-alert class="mt-3" :show="claimFormSaveMsg && claimFormSaveMsg.length > 0" :flavour="1" :resellerId="resellerIdAsNumber">{{claimFormSaveMsg}}</form-alert>
    
    <form-button-bar
        :back_button_enable='true'
        :back_button_show='true'
        :back_button_icon_enable='true'
        :back_button_action='() => $router.go(-1)'
        :save_button_enable='true'
        :save_button_show='true'
        :save_button_icon_enable='true'
        :save_button_action='handleSaveClick'
        :next_button_enable='true'
        :next_button_show='true'
        :next_button_icon_enable='true'
        :next_button_action='handleNextClick' />
</form-container>

</template>

<script>

import tigaClaimForm from '@/mixins/tigaClaimForm'
import FormContainer from '@/components/FormContainer.vue'
import FormAlert from '@/components/FormAlert.vue'
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'

import MultiRoleSelect from '@/components/MultiRoleSelect.vue';
import DeviceList from '@/components/GadgetList.vue';

const initGadget = {
  itemGUID: '',
    deviceTypeId: null,
    deviceMakeId: null,
    deviceMakeLabel: '',
    deviceModelId: null,
    deviceModelLabel: '',
    deviceIMEI: '',
    newIMEI: null,
    originalIMEI: '',
    deviceSerial: '',
    devicePurchaseDate: '',
    blacklistRequested: '',
    dateOfBlacklist: '',
    reportedToPolice: '',
    reportedToPoliceDate: '',
    policeStationAddress: '',
    policeCrimeReference: '',
    devicePolicyholderPossession: null,
    possessionDetails: {
      relationshipId: null,
      relationshipLabel: '',
      relationshipFreeText: '',
      title: null,
      firstname: '',
      lastname: '',
      email: '',
      telephone: '',
      address: {
        line1: '',
        line2: '',
        city: '',
        county: '',
        postcode: ''
      }
    },
    purchaseTypeLabel: '',
    purchaseTypeId: null,
    networkProviderId: null,
    networkProviderLabel: null,
    contractTypeId: null,
    contractTypeLabel: null,
    deviceReported: null,
    confirmIMEI: null,
    selectedDamageTypes: [],
    damageDescription: null,
    deviceSwitchOn: null,
    deviceLayFlat: null,
    relationshipTypeId: null,
    relationshipTypeLabel: null,
    purchasedBy: null,
    purchasedByPolicyHolder: null,
    devicePurchaseLocation: '',
    deviceDescription: '',
    deviceLocation: '',
    value: null
}

export default {
  name: 'gadgetList',
  mixins: [
    tigaClaimForm
  ],
  components: {
    FormContainer,
    FormAlert,
    FormButtonBar,
    MultiRoleSelect,
    DeviceList
  },
  data () {
    return {
      makeLoad:  false,
      modelLoad: false,
      customModel: false,
      customMake: false,
      isLoading: true,
      disableNextAction: true,
      selectedDeviceIndex: null,
      selectedGadgetIndex: 0,
      nextAttempted: false,
      addGadgetObj: Object.assign({}, initGadget),
      feedbackMsg: null
    }
     
  },
  beforeMount() {
    //this.fetchDeviceTypes()
  },
  mounted() {
    console.log("Mounted")
    if (!this.claimformHasPolicyNumber || 
      !this.claimformHasClaimant || 
      !this.claimformHasIncidentType || 
      !this.claimformHasClaimantUKRes ||
      !this.claimformHasClaimantVATReg ||
      !this.claimformHasIncidentDetails) {
      this.gotoStage1();
    }

    this.fetchDeviceTypes()
    this.resetDeviceMakes()
    this.resetDeviceModels()
  },
  watch: {
    deviceTypeId(val) {
      this.fetchDeviceMakes(val)
      if(this.addGadgetObj.deviceMakeId !== 0) {
        this.addGadgetObj.deviceMakeId = null;
      }      
      this.resetDeviceMakes()
      if(this.addGadgetObj.deviceModelId !== 0) {
        this.addGadgetObj.deviceModelId = null;
      }      
      this.resetDeviceModels()
      if(val === null) {
        this.customMake = false;
        this.customModel = false;
      }
    },
    deviceMakeId(val) {
      this.modelLoad = true;                    
      this.resetDeviceModels()
      this.fetchDeviceModels(this.addGadgetObj)
      if(val === null) {
        this.addGadgetObj.deviceModelId = null
        this.customModel = false;
      }
      if(val === 0 || val === null) {
        this.modelLoad = false;
      }    
    },
    deviceModels(val) {
      if(val !== null) {
        if(val.length > 0) {
          this.modelLoad = false;
        }
      }      
    },
    deviceValue(val) {
      if (val === "") {
        this.addGadgetObj.value = null;
      }
    },
    claimFormGadgets(val) {
      if(val.length > 0){
        this.disableNextAction = true;
      } else {
        this.disableNextAction = false;
      }
    } 
  },
  computed: {
    deviceTypeId() {
      return this.addGadgetObj.deviceTypeId
    },
    deviceMakeId() {
      return this.addGadgetObj.deviceMakeId
    },
    deviceValue() {
      return this.addGadgetObj.value
    },
    selectedGadget: {
      get () {
        return this.$store.state.claimform.selectedGadget
      },
      set (value) {
        this.$store.commit('claimform/setSelectedGadget', value)
      }
    },
    isCompletedRow() {
      let complete = false;
      if(this.deviceTypeId != null && this.deviceMakeId != null && 
      this.addGadgetObj.deviceModelId != null && this.addGadgetObj.value != null) {
        complete = true;
        if(this.deviceMakeId === 0) {
          complete = this.addGadgetObj.deviceMakeLabel !== "";
        }
        if(this.addGadgetObj.deviceModelId === 0) {
          complete = this.addGadgetObj.deviceModelLabel !== "";
        }
      }
      return complete;
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }       
  },
  methods: {
    deviceLabel (device) {
      if (device) {
        return `${device.deviceMakeLabel} / ${device.deviceModelLabel}`
      }
    },
    gadgetTypeIcon: (type) => ({      
        1: 'fas fa-mobile-alt',
        2: 'fa-tablet-alt',
        3: 'fa-laptop',
        5: 'fa-headphones',
        6: 'fa-gamepad',
        7: 'fa-gamepad',
        8: 'fa-camera',
        9: 'fa-camera',
        10: 'fa-video',
        11: 'fa-keyboard',
        12: 'fa-headphones',
        13: 'fa-compact-disc',
        14: 'fa-map-marked-alt',
        15: 'fa-car',
        16: 'fa-clock',
        17: 'fa-clock',
      }[type] || 'fa-mobile-alt'),
    handleNextClick () {
      this.nextAttempted = true
      this.feedbackMsg = null

      if (this.isCompletedRow) {
        this.addGadget()
        .then( (itemGUID) => {
          this.addGadgetObj = Object.assign({}, initGadget)
        })
      }

      if (this.gadgets.length > 0) {
        if (this.selectedGadget.itemGUID == null) {
          this.selectedGadgetIndex = 0
        }
        this.selectedGadget = this.gadgets[ this.selectedGadgetIndex]

        this.$router.push({ path: '101' })
      }

      this.feedbackMsg = 'You have to add the details of at least one device to your claim.'
    },
    handleSaveClick () {
      this.saveClaimForm()
    },
    handleAddGadgetClick() {
      this.addGadget()
      .then( (itemGUID) => {
        this.addGadgetObj = Object.assign({}, initGadget)
        this.feedbackMsg = null
      })
    },
    addGadget() {
      return new Promise( (resolve) => {
        this.addGadgetObj.itemGUID = this.newIdv4()
        let { deviceMakeId, deviceModelId } = this.addGadgetObj
        if(deviceMakeId !== 0) {
          this.addGadgetObj.deviceMakeLabel = this.deviceMakeById(deviceMakeId)
        } 
        if(deviceModelId !== 0) {
          this.addGadgetObj.deviceModelLabel = this.deviceModelById(deviceModelId)
        }      
        this.addUpdateGadget({ ...this.addGadgetObj })
        resolve(this.addGadgetObj.itemGUID)      
      })
    },
    customMakeSelected(val) {
      this.addGadgetObj.deviceMakeLabel = val;  
      if(val === 'edit') {
        this.customMake = true;
        this.customModel = true;
        this.addGadgetObj.deviceMakeLabel = ""; 
      } else if (val === 'stop-edit') {
        this.customMake = false;
        this.customModel = false;
        this.addGadgetObj.deviceMakeLabel = "";  
      }          
    },
    customModelSelected(val) {
      this.addGadgetObj.deviceModelLabel = val;
      if(val === 'edit') {
        this.customModel = true;
        this.addGadgetObj.deviceModelLabel = "";
      } else if (val === 'stop-edit') {
        this.customModel = false;
        this.addGadgetObj.deviceModelLabel = "";
      }      
    },
    handleRemoveGadget(gadget) {
      this.removeGadget(gadget);
    }   
  }
}
    // gadgetTypeIcon (type) {
    //   switch (type) {
    //     case 1:
    //       return 'fas fa-mobile-alt'
    //       break
    //     case 2:
    //       return 'fas fa-tablet-alt'
    //       break
    //     case 3:
    //       return 'fas fa-laptop'
    //       break
    //     case 5:
    //       return 'fas fa-headphones'
    //       break
    //     case 6:
    //       return 'fas fa-gamepad'
    //       break
    //     case 7:
    //       return 'fas fa-gamepad'
    //       break
    //     case 8:
    //       return 'fas fa-camera'
    //       break
    //     case 9:
    //       return 'fas fa-camera'
    //       break
    //     case 10:
    //       return 'fas fa-video'
    //       break
    //     case 11:
    //       return 'fas fa-keyboard'
    //       break
    //     case 12:
    //       return 'fas fa-headphones'
    //       break
    //     case 13:
    //       return 'fas fa-compact-disc'
    //       break
    //     case 14:
    //       return 'fas fa-map-marked-alt'
    //       break
    //     case 15:
    //       return 'fas fa-car'
    //       break
    //     case 16:
    //       return 'fas fa-clock'
    //       break
    //     case 17:
    //       return 'fas fa-clock'
    //       break
    //     default:
    //       return 'fas fa-mobile-alt'
    //   }
    // },
</script>